import React from 'react'
import Nav from './Component/nav/Nav'
import Header from './Component/header/Header'
import About from './Component/about/About'
import Experience from './Component/experience/Experience'
import Services from './Component/services/Services'
import Counter from './Component/counter/counter'
import Portfolio from './Component/portfolio/Portfolio'
import Testimonials from './Component/testimonials/Testimonials'
import Contact from './Component/contact/Contact'
import Footer from './Component/footer/Footer'
import ScrollButton from './Component/scrollbtn/ScrollButton'
import Skills from './Component/Skills/wordcloud'

const App = () => {
  return (
    <>
        <Nav />
        <Header />
        <ScrollButton />
        <About />
        <Skills />
        <Experience />
        <Services />
        <Counter />
        <Portfolio />
        {/* <Testimonials /> */}
        <Contact />
        <Footer />
    </>
  )
}

export default App